export const CHART_COLORS = ['hsl(var(--primary))', 'hsl(var(--secondary))', 'hsl(var(--destructive))', 'hsl(var(--chart-4))', 'hsl(var(--chart-5))', '#8b5cf6', '#06b6d4', '#f59e0b'];
